import React, { Component } from 'react';
import FJSearch from './FJSearch';
import FJConstant from '../../../constants/FJConstant';

/**
 * @desc props
 * @private {string} props.theme - 主题，如果为空则为默认样式。 theme-mini | null,目前只有2个样式
 */

class FJSearchContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            keywords: '',
            sortType: FJConstant.SORT_TYPE_RELEVANT,
            historyMaxHeight: 0,
        };
    }

    componentDidMount() {
        this._initMaxHeight();
        window.addEventListener('resize', this._initMaxHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._initMaxHeight);
    }

    _initMaxHeight = () => {
        const { propsHeight = 0 } = this.props;
        const maxHeight = document.body.clientHeight - 100 - propsHeight;
        this.setState({
            historyMaxHeight: maxHeight,
        });
    };

    render() {
        let {
            placeHolder,
            couldSort,
            style,
            onClearHistory,
            history,
            className,
            theme,
            populars = [],
            isElement,
            hasAutoComplete = false,
            completeList = [],
            hasSearchType,
            searchTypeList,
            onSearchTypeChange,
            categorySort,
            onSearchMultipleChange,
            enableFilter,
            filterData,
            enableFilterColors,
            filterRatioData,
            onRadioChange,
            hasIcon,
            iconSrc,
            onBlur,
            onFocus,
            onClear,
            isDisabled,
            inputStyle,
            hasMaxLength = true,
        } = this.props;
        let { keywords, sortType, historyMaxHeight } = this.state;
        return (
            <FJSearch
                ref={ele => (this._searchRef = ele)}
                onSortChange={this.onSortChange}
                onChange={this.onValueChange}
                onSubmit={this.onSearch}
                onClearHistory={onClearHistory}
                style={style}
                className={className}
                isElement={isElement}
                theme={theme}
                value={keywords}
                history={history}
                sortType={sortType}
                placeHolder={placeHolder}
                couldSort={couldSort}
                populars={populars}
                hasAutoComplete={hasAutoComplete}
                completeList={completeList}
                setKeywords={this.setKeywords}
                maxHeight={historyMaxHeight}
                hasSearchType={hasSearchType}
                searchTypeList={searchTypeList}
                onSearchTypeChange={onSearchTypeChange}
                categorySort={categorySort}
                onSearchMultipleChange={onSearchMultipleChange}
                enableFilter={enableFilter}
                filterData={filterData}
                enableFilterColors={enableFilterColors}
                filterRatioData={filterRatioData}
                onRadioChange={onRadioChange}
                hasIcon={hasIcon}
                iconSrc={iconSrc}
                isDisabled={isDisabled}
                onBlur={onBlur}
                onFocus={onFocus}
                onClear={onClear}
                inputStyle={inputStyle}
                hasMaxLength={hasMaxLength}
            />
        );
    }

    onSortChange = sortType => {
        this.setState({ sortType }, this.onSearch);
    };
    onValueChange = keywords => {
        this.setState({ keywords }, () => {
            if (keywords === '') {
                this.onSearch();
            }
        });
        this.props.onChange && this.props.onChange(keywords);
    };
    onSearch = (value, isHartWords = false) => {
        let { keywords } = this.state;
        this.props.search(value || keywords, isHartWords);
    };

    onSearchTrim = () => {
        const { keywords } = this.state;
        const useKeywords = keywords.trim();
        if (useKeywords === '') {
            this.setState({ keywords: useKeywords });
            this.props.onChange(useKeywords);
        } else {
            this.props.search(useKeywords);
        }
    };

    /**
     * @desc
     * @return {searchFrom, orientation} - searchFrom搜索的来源的数组，orientation素材的比例
     */
    getSearchFilterData = () => {
        return this._searchRef.getSearchFilterData();
    };

    focus = () => {
        this._searchRef.focus();
    };

    updateValue = keywords => {
        this.setState({ keywords });
    };
    getKeywords = () => {
        return this.state.keywords;
    };
    getSortType = () => {
        return this.state.sortType;
    };
    setKeywords = value => {
        this.setState({
            keywords: value,
        });
    };
}

export default FJSearchContainer;
